import React, { FC, ReactNode, useMemo } from "react";

import ReactDOM from "react-dom/client";
import {
  ConnectionProvider,
  WalletProvider
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { clusterApiUrl } from "@solana/web3.js";
import "@solana/wallet-adapter-react-ui/styles.css";

import App from "./App";
import "./App.css";
import reportWebVitals from "./reportWebVitals";


const SolanaProvider: FC = ({ children }) => {
  // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'
  const network = WalletAdapterNetwork.Mainnet;

  // You can also provide a custom RPC endpoint
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={[]} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<SolanaProvider>
		<App>
		
		</App>
	</SolanaProvider>
);

reportWebVitals();
